import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    inject,
    input,
    OnInit,
    output,
    viewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { firstValueFrom } from 'rxjs';

import { excludedAttributes } from '@connect-services/client/services/layer.service';
import { CreateLayerDtoWithoutProject } from '@connect-services/client/services/layer-creation-form.service';
import { DepositsService, DepositTableColumn, Layer } from '@connect-services/src/sdk/api';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-add-layer-business-identifier',
    templateUrl: './add-layer-business-identifier.component.html',
})
export class AddLayerBusinessIdentifierComponent implements OnInit {
    public columnControl = new FormControl<string | null>(null);
    public columnSelection = output<string | null>();
    public columnsList!: DepositTableColumn[];
    public readonly currentBusinessIdentifierValue = input<string | null>(null);
    public filteredColumnsList!: DepositTableColumn[];
    public readonly input = viewChild.required<ElementRef<HTMLInputElement>>('input');
    public readonly layer = input.required<CreateLayerDtoWithoutProject | Layer>();

    private readonly depositService = inject(DepositsService);

    public filterColumnList(): void {
        const filterValue = this.input().nativeElement.value.toLowerCase();
        if (!filterValue) {
            this.filteredColumnsList = this.columnsList;
        }

        this.filteredColumnsList = this.columnsList.filter((column: DepositTableColumn) =>
            column.name.toLowerCase().includes(filterValue),
        );
    }

    public async ngOnInit(): Promise<void> {
        if (!this.layer().tableName || !this.layer().deposit) {
            throw new Error('Layer must be of type table');
        }

        this.columnControl.setValue(this.currentBusinessIdentifierValue() ?? this.layer().businessIdentifier ?? null);

        this.columnsList = (
            await firstValueFrom(
                this.depositService.depositControllerGetTableColumns({
                    id: this.layer().deposit!,
                    tableName: this.layer().tableName!,
                }),
            )
        ).filter((column: DepositTableColumn) => !excludedAttributes.includes(column.name));

        this.filteredColumnsList = this.columnsList;
    }
}
